module.exports = __webpack_public_path__ + "static/media/icon-how-it-works7.eb496c56.svg";